<script setup lang="ts">
import { MultiSelect } from '@collector/shared-ui'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables'
import { useEventStatuses } from '@desktop/views/Relation/Sports/composables'

import { injectSuccessBadge } from '../../successBadge'

// inject
const { showSuccessBadge } = injectSuccessBadge()

// composables
const { event } = useEvent()
const { eventStatuses } = useEventStatuses()

async function updateValue(value: number): Promise<void> {
  await sportsApiClient.Events.patch(event.value.id, {
    event: { event_status_id: value },
  })

  showSuccessBadge()
}
</script>

<template>
  <MultiSelect
    :options="eventStatuses"
    :modelValue="event.status_id"
    @update:modelValue="updateValue($event as number)"
  >
    <span class="w-12">Match status</span>
  </MultiSelect>
</template>
